import { render } from "./JourneyTab.vue?vue&type=template&id=2e3a82dd&scoped=true"
import script from "./JourneyTab.vue?vue&type=script&lang=js"
export * from "./JourneyTab.vue?vue&type=script&lang=js"

import "./JourneyTab.vue?vue&type=style&index=0&id=2e3a82dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3a82dd"]])

export default __exports__